var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{class:{ mx_recaptcha_failed: !_vm.recaptcha }},[_c('VueRecaptcha',{attrs:{"sitekey":_vm.recaptchaSiteKey},on:{"verify":_vm.mxVerify}}),_c('br'),_c('small',[_vm._v("Doesn't complete!")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }